<template>
  <div class="page-home">
    <header>
      <div v-show="!data.hideLogin">
        <app-header
          v-on:logged="chageLogged"
          v-on:login="login"/>
      </div>
      <div v-show="data.hideLogin" @click="data.hideLogin = false">
        <img class="logo-sandwich" alt="CotriDrive" :src="require('@/assets/logo.png')">
        <span class="menu-sandwich">
          <div class="sandwich"></div>
          <div class="sandwich"></div>
          <div class="sandwich"></div>
        </span>
      </div>
      <action-header v-show="data.logged" v-on:voltar="acaoHeader"/>
    </header>
    <div v-show="data.logged" class="content-list-carrinho" @click="data.hideLogin = true">
      <div id="tabela-carrinho" class="tabela-carrinho" v-show="data.carrinho.length > 0">
        <table id="listacarrinho">
          <thead>
            <tr>
              <th>
              </th>
              <th class="text-left">
                <span title="Descrição">
                  Descrição</span>
              </th>
              <th class="text-left">
                <span title="Preço">
                  Preço</span>
              </th>
              <th>
              </th>
            </tr>
          </thead>
          <tbody class="dados-carrinho">
            <tr v-for="(item) in data.carrinho"
              :key="item.id">
              <td class="td-img"><img v-if="item.imagem_principal" :src=item.imagem_principal.url ></td>
              <td class="text-left">
                <span v-html="descricao(item)"></span>
              </td>
              <td class="text-preco">{{preco(item) }}</td>
              <td class="botoes-principal">
                <btn-round v-if="item.quantidade !=  1" v-bind:sinal="'-'"
                  @click="menos(item.id)" />
                <label style="width:auto; font-size:0.8rem; color: #C2171A; margin: 5px" v-if="item.quantidade === 1" title="deletar"
                  @click="menos(item.id)">Excluir</label>
                <input type="number" id="qtd" @change="changeQtd(item.id)" class="quantidade" v-model.number="item.quantidade">
                <btn-round v-bind:sinal="'+'"
                  @click="mais(item.id)" /> </td>
            </tr>
          </tbody>
        </table>
        <template>
          <div v-if="data.showLoader === true" class="loader"></div>
        </template>
        <div class="total" v-if="total > 0" >
          <h2 class="textTotal">Total:  {{total.toFixed(2)}}</h2>
        </div>
      </div>
      <transition name="empty-car">
        <div v-if="data.carrinho == 0"  class="emptyState">
          <img width="200" :src="emptyState" alt="Empty State">
          <h4>Para adicionar itens à sua lista de compras utilize o botão <br/> + ADICIONAR ITENS!</h4>
        </div>
      </transition>
      <Suspense>
        <select-product
          v-bind="data.showModal"
          :oferta="data.showModalOfertas"
          v-if="data.showModal"
          v-on:fechar-modal-SelectProduct="carregarLista"/>
      </Suspense>
      <Suspense>
        <ModalFinalizacao
          v-show="data.showModalFinalizacao"
          v-model="data.confirmouFinalizacao"
          :obs="data.observacao"
          @update:obs="data.observacao = $event"
          :title="'Atenção'"
          :text="data.textoFinalizacao"
          :valorTotal="total"
          v-on:close="data.showModalFinalizacao = false; sendPedido()"/>
      </Suspense>
      <Suspense>
        <dialog-modal
          v-show="data.showDialogModal"
          v-model="data.limparLista"
          :title="'Atenção'"
          :text="data.textoFinalizacao"
          v-on:close="data.showDialogModal = false; limpar()"
        />
      </Suspense>
      <Suspense>
        <message-modal
          v-show="data.showDialogModalPedidoEnviado"
          :title="'Atenção'"
          :text="data.textoFinalizacao"
          v-on:close="data.showDialogModalPedidoEnviado = false; resetPage()"
        />
      </Suspense>
    </div>
    <transition name="empty-data">
      <div v-if="!data.logged"  class="emptyState">
        <img width="200" :src="emptyState" alt="Empty State">
        <h4>Informe os Dados solicitados para iniciar suas compras!</h4>
      </div>
    </transition>
  </div>
</template>

<script>
import { reactive } from 'vue'
import AppHeader from '@/components/header/AppHeader.vue'
import ActionHeader from '@/components/header/ActionHeader.vue'
import SelectProduct from '@/components/modais/SelectProduct.vue'
import BtnRound from '@/components/uteis/BtnRound.vue'
import ModalFinalizacao from '@/components/modais/ModalFinalizacao.vue'
import DialogModal from '@/components/modais/Dialog.vue'
import MessageModal from '@/components/modais/MessageModal.vue'
import axios from 'axios'
import moment from 'moment'
import store from '@/store'
import { notify } from '@kyvg/vue3-notification'
import router from '@/router'
import emptyState from '../assets/empty.svg'
import { precoProduto } from '@/components/funcoes/precoProduto'
import { descricaoProduto } from '@/components/funcoes/descricaoProduto'

const url = process.env.VUE_APP_API_URL

export default ({
  name: 'Lista Produto',
  components: {
    AppHeader,
    ActionHeader,
    SelectProduct,
    BtnRound,
    ModalFinalizacao,
    DialogModal,
    MessageModal
  },
  setup () {
    const data = reactive({
      currentTime: moment(),
      carrinho: [],
      showModal: false,
      showModalOfertas: false,
      showLoader: false,
      logged: false,
      dadosCadastro: [],
      hideLogin: false,
      showModalFinalizacao: false,
      confirmouFinalizacao: false,
      textoFinalizacao: [],
      observacao: '',
      showDialogModal: false,
      showDialogModalPedidoEnviado: false,
      limparLista: false
    })

    const carregarLista = (selectedProducts = Array) => {
      data.showModal = false
      data.showModalOfertas = false
      // console.log(isReactive(selectedProducts))
      if (Object.keys(selectedProducts).length > 0) {
        selectedProducts.forEach(element => {
          const index = data.carrinho.findIndex((item) => item.id === element.id)
          if (index === -1) {
            data.carrinho.push(element)
          } else {
            if (data.carrinho[index].id === element.id) {
              data.carrinho[index].quantidade += element.quantidade
            }
          }
        })
      }
      localStorage.setItem('carrinho', JSON.stringify(data.carrinho))
      localStorage.setItem('carrinhoDate', JSON.stringify(data.currentTime))
    }

    const login = (dadosCliente) => {
      data.logged = true
      data.dadosCadastro = dadosCliente
      const carrinhoLocal = localStorage.getItem('carrinho')
      const carrinhoDate = moment(localStorage.getItem('carrinhoDate'), 'YYYY-MM-DD')
      if (carrinhoLocal != null & data.carrinho.length === 0) {
        if (carrinhoDate.format('LL') === data.currentTime.format('LL')) {
          data.carrinho = JSON.parse(carrinhoLocal)
        } else {
          data.carrinho = []
        }
      }
      store.commit('setCarrinho', data.carrinho)
    }

    const chageLogged = (logged) => {
      data.logged = logged
    }

    const acaoHeader = (acao) => {
      switch (acao) {
        case 'adicionar':
          data.showModal = true
          data.hideLogin = true
          break
        case 'ofertas':
          data.showModalOfertas = true
          data.showModal = true
          data.hideLogin = true
          break
        case 'limpar':
          if (data.carrinho.length > 0) {
            data.limparLista = false
            data.textoFinalizacao = []
            data.textoFinalizacao[0] = 'Tem certeza que deseja Limpar a Lista?'
            data.showDialogModal = true
          } else {
            notify({
              title: 'Limpar Lista',
              text: 'Não existem Itens na Lista para serem limpos',
              type: 'info',
              duration: 10000,
              speed: 1000
            })
          }
          break
        case 'enviar':
          if (data.carrinho.length > 0 && data.dadosCadastro.telefone.length > 0 && data.dadosCadastro.nome.length > 0) {
            data.showLoader = true
            data.textoFinalizacao[0] = '- Produtos por quilo podem sofrer pequena alteração de valor em função do peso final.'
            data.textoFinalizacao[1] = '- Os produtos estão sujeitos a disponibilidade em estoque.'
            data.textoFinalizacao[2] = 'Confirmar o envio do Pedido?'
            data.showModalFinalizacao = true
          } else {
            notify({
              title: 'Envio',
              text: `Não é possível enviar o pedido,
                verifique se existem produtos no carrinho, Telefone e Nome preenchidos`,
              type: 'info',
              duration: 10000,
              speed: 1000
            })
          }
          // sendPedido()
          break
        default:
          console.log('Ação não encontrada')
      }
    }

    const validaQtd = (produto) => {
      if (produto.quantidade < 0 || (!Number.isInteger(produto.quantidade))) {
        if (produto.quantidade < 0 ||
          ((produto.erp_fl_qt_decimal && produto.erp_fl_qt_decimal !== 'S') ||
          !produto.erp_fl_qt_decimal)) {
          const index = data.carrinho.findIndex((item) => item.id === produto.id)
          data.carrinho[index].quantidade = 1
        }
        if (typeof produto.quantidade === 'string') {
          const index = data.carrinho.findIndex((item) => item.id === produto.id)
          data.carrinho[index].quantidade = 1
        }
      }
    }

    const changeQtd = (proId) => {
      const index = data.carrinho.findIndex((item) => item.id === proId)
      store.commit('setCarrinho', data.carrinho)
      localStorage.setItem('carrinho', JSON.stringify(data.carrinho))
      validaQtd(data.carrinho[index])
      if (data.carrinho[index].quantidade === 0) {
        data.carrinho.splice(index, 1)
        localStorage.setItem('carrinho', JSON.stringify(data.carrinho))
      }
    }

    const menos = (proId) => {
      const index = data.carrinho.findIndex((item) => item.id === proId)
      if (data.carrinho[index].quantidade !== 0) {
        data.carrinho[index].quantidade -= 1
        if (data.carrinho[index].quantidade === 0) {
          data.carrinho.splice(index, 1)
          localStorage.setItem('carrinho', JSON.stringify(data.carrinho))
        } else {
          validaQtd(data.carrinho[index])
        }
      }
    }
    const mais = (proId) => {
      const index = data.carrinho.findIndex((item) => item.id === proId)
      data.carrinho[index].quantidade += 1
      localStorage.setItem('carrinho', JSON.stringify(data.carrinho))
    }

    const sendPedido = async () => {
      if (data.confirmouFinalizacao === true) {
        const produtos = []
        data.carrinho.forEach(element => {
          var pro = {}
          pro.codpro = element.codigo_cotripal
          pro.nome = element.descricao.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase()
          pro.preco = preco(element)
          pro.qtde = element.quantidade.toFixed(3)
          pro.um_erp = element.um_erp

          pro.total = (pro.qtde * pro.preco).toFixed(2)
          produtos.push(pro)
        })

        data.dadosCadastro.nome = data.dadosCadastro.nome.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase()

        await axios
          .post(`${url}pedidos/`, {
            produtos: produtos,
            pessoa: data.dadosCadastro,
            obs: data.observacao.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase()
          })
          .then((response) => {
            if (response.status === 200 && response.data.status === 200) {
              // alert('Pedido Enviado...')
              notify({
                title: 'Envio do Pedido',
                text: 'Seu Pedido foi Enviado!',
                type: 'success',
                duration: 10000,
                speed: 1000
              })
              data.textoFinalizacao = []
              data.textoFinalizacao[0] = 'Seu pedido foi enviado!'
              data.textoFinalizacao[1] = 'Aguarde atualizações sobre o seu pedido no número informado.'
              data.showDialogModalPedidoEnviado = true
            } else if (response.data.status === 500) {
              // alert(response.data.data.message)
              notify({
                title: 'Envio do Pedido',
                text: response.data.data.message,
                type: 'error',
                duration: 10000,
                speed: 1000
              })
            }
          })
          .catch(function (error) {
            console.log(error)
            notify({
              title: 'Envio do Pedido',
              text: `Erro Inesperado: ${error}`,
              type: 'error',
              duration: 10000,
              speed: 1000
            })
          })
        data.showLoader = false
      }
    }

    const resetPage = async () => {
      data.carrinho = []
      data.dadosCadastro = []
      data.hideLogin = false
      data.observacao = ''
      localStorage.setItem('carrinho', JSON.stringify(data.carrinho))
      localStorage.removeItem('carrinhoDate')
      document.location.reload(true)
    }

    const preco = (produto) => {
      return precoProduto(produto)
    }

    const descricao = (produto) => {
      return descricaoProduto(produto)
    }

    const limpar = () => {
      if (data.limparLista === true) {
        data.carrinho = []
        // data.total = (0.00)
        localStorage.setItem('carrinho', JSON.stringify(data.carrinho))
        localStorage.removeItem('carrinhoDate')
      }
    }

    return { data, carregarLista, login, chageLogged, acaoHeader, validaQtd, changeQtd, menos, mais, sendPedido, preco, limpar, descricao, resetPage, emptyState }
  },
  computed: {
    total () {
      var valorTotal = (0.00)
      this.data.carrinho.forEach(element => {
        valorTotal += (parseFloat(this.preco(element)) * element.quantidade)
      })
      return valorTotal
    },
    quatidade (produto) {
      // mostra notify
      const index = this.data.carrinho.findIndex((item) => item.id === produto.id)
      return this.data.carrinho[index].quantidade
    }
  }
})
</script>

<style lang="scss">
  .page-home {
    width: 100%;
    height: 100vh;
    position:relative;
    margin: 0;
    background: rgb(255, 255, 255);
    overflow-x:hidden;
  }
  header{
    .logo-sandwich {
      position: relative;
      width: 13%;
      height: auto;
      left: 5px;
      margin: 5px;
    }

    .menu-sandwich{
      right: 5%;
      position: fixed;
      margin: 5px;
    }

    .sandwich {
      width: 35px;
      height: 5px;
      background-color: #C2171A;
      margin: 6px 0;
    }
  }
  .content-list-carrinho {
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 30px rgba(211, 211, 211, 0.25);
    position:relative;
    width: 100%;

    .tabela-carrinho{
      background: #fff;
      float: left;
      position: relative;
      width: 100%;
      height: 79vh;
      overflow-y: auto;
      /*max-height: (70vh, calc(100vh - 50rem), 516px);*/

      #listacarrinho{
        position: relative;
        border-collapse: collapse;
        border-spacing: 0;
        width: 100%;
        height: auto;
        overflow-x: hidden;
      }

      thead th {
        position: sticky;
        top: 0;
        background-color: rgb(187, 187, 187);
        text-align: left;
        padding: 5px;
      }

      tbody td {
        position: relative;
        font-size: clamp(1rem, 0.6250rem , 1.5rem);
        text-align: left !important;

        span {
          position: relative;
          align-self: center;
          color: black;
          white-space: inherit;
        }

      }
      tbody td.text-preco {
        font-weight: 600;
      }

      tbody td.botoes-principal {
        min-width: 50px;
        position: relative;
        width: auto;
        display:inline;
        align-content: center;
        align-items: center;
      }

      tbody td.td-img {
        text-align: left !important;
        margin-right: 0;

        img {
          align-content: center;
          margin: 0.2rem;
          max-width: clamp(3rem, 5rem, 6rem);
          min-width: 2rem;
        }
      }

      tbody tr:nth-child(even) {
        background-color: #f2f2f2;
      }

      tbody tr:hover {
        background-color: #FFEC00 !important;
      }
    };
    .quantidade {
      width: 2rem;
    }
  }
  div.total {
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    background-color: #ffee00ef;
    position:sticky;
    left: 0;
    bottom: 5px;
    width: 100%;
    color: #C2171A;
    text-align: right;
    padding: 0.5rem;

    h2 {
      margin-right: 3rem;
    }
  }

  .emptyState {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem;
  }

  .empty-car-enter-active, .empty-car-leave-active {
    transition: opacity .5s;
  }
  .empty-car-enter, .empty-car-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
    opacity: 0;
  }

  .empty-data-enter-active, .empty-car-leave-active {
    transition: opacity .5s;
  }
  .empty-data-enter, .empty-car-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
    opacity: 0;
  }
</style>
